<template>
  <modal id="result-modal" title="Hasil Quiz">
    <div class="tabs" v-if="show_evaluation">
      <ul>
        <li :class="tab == 0 ? 'is-active' : ''"><a @click.prevent="tab = 0">Hasil Tes</a></li>
        <li v-if="(pt.type == 'ADMIN' || pt.type == 'LECTURER')" :class="tab == 1 ? 'is-active' : ''"><a @click.prevent="tab = 1">Evaluasi</a></li>
      </ul>
    </div>

    <div class="columns" v-if="tab == 0 && !isEmpty(resultQuiz)">
      <div class="column is-4">
        <div class="box is-primary has-text-centered">
          <p class="subtitle is-5 has-text-white">Nilai Quiz</p>
          <p class="title is-2 has-text-white">{{ resultQuiz.totalScore }}</p>
        </div>
      </div>

      <div class="column">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label for="" class="has-text-grey">Total Soal</label>
              <div class="control">
                <p><strong>{{ quiz.questions.length }} Soal</strong></p>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <div class="field">
              <label for="" class="has-text-grey">Benar</label>
              <div class="control">
                <p><strong class="has-text-success">{{ resultQuiz.totalCorrect }}</strong></p>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label for="" class="has-text-grey">Salah</label>
              <div class="control">
                <p><strong class="has-text-danger">{{ resultQuiz.totalWrong }}</strong></p>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <div class="field">
              <label for="" class="has-text-grey">Tanggal Tes</label>
              <div class="control">
                <p><strong>{{ getDate(quiz.startedAt) }}</strong></p>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label for="" class="has-text-grey">Waktu Tes</label>
              <div class="control">
                <p><strong>{{ getTimeOfDate(quiz.startedAt) }} - {{ getTimeOfDate(quiz.finishedAt) }}</strong></p>
                <p class="has-text-grey"><small class="has-text-info">{{ time_to_run_quiz }} Menit</small></p>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="pt.type == 'ADMIN' || pt.type == 'LECTURER'">
          <div class="column">
            <div class="field">
              <label for="" class="has-text-grey">Peluang Curang</label>
              <div class="control">
                <p><strong class="has-text-danger">{{ resultQuiz.cheatOpportunity }} Kali</strong></p>
              </div>
            </div>
          </div>
        </div>

        <br v-if="show_back_group">

        <nuxt-link :to="`/panel/groups/${quiz.group_id}/${quiz.postId}`" class="button is-primary" style="margin-bottom: 0;" v-if="show_back_group">Kembali ke Grup</nuxt-link>
        <br v-if="show_back_group">
        <br>
      </div>
    </div>

    <div v-if="tab == 1 && quiz.status == 2 && show_evaluation" class="table-container">
      <table class="table is-bordered is-fullwidth">
        <thead>
          <tr>
            <th>No.</th>
            <th>Pertanyaan</th>
            <th>Jawaban</th>
            <th>Nilai</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(q, key) in quiz.questions" :key="key">
            <td width="5%">#{{ parseInt(key) + 1 }}</td>
            <td>{{ q.body }}</td>
            <td>
              <div v-for="(answer, a_key) in q.answers" :key="a_key" style="margin-bottom: 5px;">
                <button class="button is-small"
                  :class="{
                    'is-info': q.answer_value != q.correctAnswer && q.correctAnswer == answer.value,
                    'is-danger': q.answer_value != q.correctAnswer && q.answer_value == answer.value,
                    'is-success': q.answer_value == q.correctAnswer && q.correctAnswer == answer.value,
                  }"
                >
                  {{ keyAlphabet(!isEmpty(answer.value) ? answer.value : 0) }}
                </button>
                <button class="button is-text is-small">{{ answer.body }}</button>
              </div>
            </td>
            <td>{{ q.answer_value == q.correctAnswer ? q.score : 0 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import Modal from '~/components/containers/Modal';

export default {
  components: {
    Modal
  },
  
  props: {
    quiz: {
      type: Object,
      required: true
    },
    quiz_member_id: {
      type: String|Number,
      required: true
    },
    show_evaluation: {
      type: Boolean,
      default: true
    },
    show_back_group: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapState({
      pt: state => state.auth.active_pt
    }),
    resultQuiz() {
      return collect(this.quiz.ranks).where('quizMemberId', '==', this.quiz_member_id).first();
    },
    time_to_run_quiz() {
      const start = moment(this.quiz.startedAt);
      const finish = moment(this.quiz.finishedAt);

      return finish.diff(start, 'minutes');
    }
  },

  data() {
    return {
      tab: 0
    }
  },
}
</script>

<style>

</style>
